module.exports = __webpack_public_path__ + "static/media/company-video.24c589f9.mp4";